<div class="page-heading">
    <h2>Collaborators & publications</h2>
    <p>The Screen for EPI in CP tool was developed in collaboration between pancreatology experts and AbbVie Inc.</p>
</div>
<!-- US pancreatology expert contributors -->
<ul class="contributor dark-bg">
    <h3>US pancreatology expert contributors</h3>
    <li class="contributor__profile" *ngFor="let contributor of usPancreatology">
        <picture class="cta__image">
            <source media="(max-width: 360px)" srcset="{{contributor.imageUrl}}-mobile.png">
            <source media="(max-width: 719px)" srcset="{{contributor.imageUrl}}-mobile@2x.png">
            <source media="(max-width: 1440px)" srcset="{{contributor.imageUrl}}.png">
            <source media="(max-width: 2880px)" srcset="{{contributor.imageUrl}}@2x.png">
            <img src="{{contributor.imageUrl}}@3x.png" alt="About this tool image">
        </picture>
        <div class="contributor__info">
            <p class="contributor__copy name">{{contributor.name}}</p>
            <p class="contributor__copy" *ngFor="let info of contributor.information"><i>{{info}}</i></p>
            <p class="contributor__copy">{{contributor.location}}</p>
            <p class="recent-publications"><a (click)="leaveSite(contributor.name)">Recent Publications</a> (opens in a new tab)</p>
            <div class="contributor__dropdown" (click)="toggleDropdown(contributor.name, ContributorType.UsPancreatology)">
                <div class="horizontal-block">
                    <p class="research-interests">Research interests</p>
                    <img src="assets/icons/icon-dropdown-arrow-black.svg" alt="" [ngClass]="{'rotate180': contributor.dropdown}">
                </div>
                <p *ngIf="contributor.dropdown" class="copy">{{contributor.interests}}</p>
            </div>
        </div>
    </li>
</ul>
<!-- AbbVie contributors -->
<ul class="contributor">
    <h3>AbbVie contributors</h3>
    <li class="contributor__profile" *ngFor="let contributor of abbvie">
        <picture class="cta__image">
            <source media="(max-width: 360px)" srcset="{{contributor.imageUrl}}-mobile.png">
            <source media="(max-width: 719px)" srcset="{{contributor.imageUrl}}-mobile@2x.png">
            <source media="(max-width: 1440px)" srcset="{{contributor.imageUrl}}.png">
            <source media="(max-width: 2880px)" srcset="{{contributor.imageUrl}}@2x.png">
            <img src="{{contributor.imageUrl}}@3x.png" alt="About this tool image">
        </picture>
        <div class="contributor__info">
            <p class="contributor__copy name">{{contributor.name}}</p>
            <p class="contributor__copy" *ngFor="let info of contributor.information"><i>{{info}}</i></p>
            <div class="contributor__dropdown" (click)="toggleDropdown(contributor.name, ContributorType.Abbvie)">
                <div class="horizontal-block">
                    <p class="research-interests">Research interests</p>
                    <img src="assets/icons/icon-dropdown-arrow-black.svg" alt="" [ngClass]="{'rotate180': contributor.dropdown}">
                </div>
                <p *ngIf="contributor.dropdown" class="copy">{{contributor.interests}}</p>
            </div>
        </div>
    </li>
</ul>
<!-- Additional Information Columns -->
<div class="c-columns c-columns--development">
    <h2>Additional Information</h2>
    <div class="column">
        <h4 class="column__title">Development of the tool</h4>
        <p class="column__copy">Discover how the screening tool was developed.</p>
        <app-button text="Find out more" path="development" tab="developing-the-tool" (btnClick)="track('collaborators-publications-developing-the-tool-cta')"></app-button>
    </div>
    <div class="column">
        <h4 class="column__title">Considerations & limitations</h4>
        <p class="column__copy">Additional information on the methodological considerations and limitations.</p>
        <app-button text="Find out more" path="development" tab="considerations-limitations" (btnClick)="track('collaborators-publications-considerations-limitations-cta')"></app-button>
    </div>
</div>
<app-bottom-navigation backRoute="development" backTab="considerations-limitations" backText="Considerations & limitations" continueRoute="screening-tool-landing" continueTab="introduction" continueText="Introducing the screening tool"></app-bottom-navigation>
<!-- Leaving site modal to move -->
<app-leaving-site-modal *ngIf="leavingSite" [url]="url" continueLabel="View recent publications on the PubMed website" (modalClose)="closeLeavingSiteModal($event)"></app-leaving-site-modal>